import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { CTA, Heading, LayoutPageWrapper } from 'goustouicomponents'
import classnames from 'classnames'
import css from './HeroMessage.module.css'
import { chevronDownWhite } from '../../assets/icons/Chevrons'

const HeroMessage = ({ openingsRef }) => {
  const scrollToOpenings = () => openingsRef.current.scrollIntoView({ behavior: 'smooth' })
  const btnRef = useRef(null)
  const [isSticky, setIsSticky] = useState()
  const [showOpeningsBtn, setShowOpeningsBtn] = useState(true)

  useEffect(() => {
    const listenForScroll = () => {
      setShowOpeningsBtn(openingsRef.current.getBoundingClientRect().top >= window.innerHeight)

      if (btnRef.current) {
        setIsSticky(btnRef.current.getBoundingClientRect().bottom <= 0)
      }
    }

    window.addEventListener('scroll', listenForScroll)

    return () => window.removeEventListener('scroll', listenForScroll)
  })

  return (
    <section className={css.wrapper}>
      <LayoutPageWrapper>
        <div className={css.contentWrapper}>
          <Heading size="fontStyle4XL" type="h1" hasMargin>
            Give your career some Gousto
          </Heading>
          {showOpeningsBtn && (
            <div className={css.openingsCTAWrapper} ref={btnRef}>
              <div className={classnames({ [css.isSticky]: isSticky })}>
                <CTA isFullWidth="small-screens-only" onClick={scrollToOpenings}>
                  <span className={css.cta}>
                    <span className={css.ctaText}>Openings</span>
                    {chevronDownWhite}
                  </span>
                </CTA>
              </div>
            </div>
          )}
        </div>
      </LayoutPageWrapper>
    </section>
  )
}

export { HeroMessage }

HeroMessage.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  openingsRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.object })]).isRequired,
}
